const en = require('./en/translation.json');
const fr = require('./fr/translation.json');

const resources = {
  fr: { translation: fr },
  en: { translation: en },
};

const languages = Object.keys(resources);
const languagesName = {
  fr: 'Français',
  en: 'English',
};

const languagesMonth = {
  fr: {
    short: [
      'Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin',
      'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec',
    ],
    long:  [
      'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
      'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'décembre',
    ],
  },
  en: {
    short: [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ],
    long: [
      'january', 'february', 'march', 'april', 'may', 'june',
      'july', 'august', 'september', 'october', 'november', 'december',
    ],
  },
};

module.exports = {
  resources,
  languages,
  languagesName,
  languagesMonth,
};
